import { transactionsAdapter } from "./transactions-reducer";
import { RootState } from "../root-reducer";

// Generate selectors using the entity adapter's getSelectors method.
export const {
  selectAll: selectAllTransactions, // Returns an array of all transactions.
  selectById: selectTransactionById, // Returns a transaction by its id.
  selectIds: selectTransactionIds, // Returns an array of all transaction ids.
} = transactionsAdapter.getSelectors((state: RootState) => state.transactions);
